const CLOUD_FRONT_BASE_URL = 'https://d1qe175ag6ucb0.cloudfront.net';
const CLOUD_FRONT_HOST = 'd1qe175ag6ucb0.cloudfront.net';

const S3_VIRTUAL_HOST_REGEX = /^([^.]+)\.s3(?:\.[a-z0-9-]+)?\.amazonaws\.com$/i;
const S3_PATH_STYLE_HOST_REGEX = /^s3(?:\.[a-z0-9-]+)?\.amazonaws\.com$/i;

export const normalizeCdnUrl = <T extends string | null | undefined>(url: T): T => {
  if (!url || !import.meta.env.PROD) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.hostname === CLOUD_FRONT_HOST) {
      return url;
    }

    let key = '';

    if (S3_VIRTUAL_HOST_REGEX.test(parsedUrl.hostname)) {
      key = parsedUrl.pathname.replace(/^\/+/, '');
    } else if (S3_PATH_STYLE_HOST_REGEX.test(parsedUrl.hostname)) {
      const pathSegments = parsedUrl.pathname.replace(/^\/+/, '').split('/');
      const [, ...keyParts] = pathSegments;
      key = keyParts.join('/');
    } else {
      return url;
    }

    if (!key) {
      return url;
    }

    return `${CLOUD_FRONT_BASE_URL}/${key}${parsedUrl.search}${parsedUrl.hash}` as T;
  } catch {
    return url;
  }
};
